import axios from 'axios'
import store from '../store'

export default function (data) {
  return axios({
    method: 'post',
    url: 'reset',
    baseURL: store.state.env.api_base,
    headers: {
      'Accept': 'application/json'
    },
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/postReset.js